/**
 * カートページのギフトラッピング追加。もとは sekka-cart.liquid のインラインscriptだった。
 * カート更新フォームの中にボタンがあるので submit は使えず、fetch で足す。
 *
 * 追加先のURLはLiquidの routes.cart_add_url をボタンの data-sk-cart-url に
 * 出してもらって読む。外部ファイルにLiquidは書けないため。
 */
(function () {
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sk-gift-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    var T = (window.Sekka && window.Sekka.t) || {};
    btn.textContent = T.adding || 'Adding…';
    fetch((btn.dataset.skCartUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.skGiftAdd), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = T.add_failed || 'Please try again';
      });
  });

  /**
   * クーポンコード（2026-08-12）。Shopifyは /discount/コード に遷移すると
   * コードをCookieへ保存し、ご購入手続き画面で自動適用する。
   * カート更新フォームの中なのでボタンはsubmitにできず、ここで遷移する。
   * 適用後はカートへ ?sk_coupon=コード 付きで戻し、ご案内文を表示する。
   */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-sk-coupon-apply]');
    if (!btn) return;
    var input = document.querySelector('[data-sk-coupon-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }
    var root = btn.dataset.skRoot || '/';
    var cart = btn.dataset.skCart || '/cart';
    // /discount/ の戻り先パラメータは redirect（return_to は無視されて / に戻る。2026-08-12に実測）
    var back = cart + '?sk_coupon=' + encodeURIComponent(code);
    window.location.href = root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });

  // Enterでも適用できるように（数量inputのonchange submitとは別物）
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var input = ev.target.closest('[data-sk-coupon-input]');
    if (!input) return;
    ev.preventDefault();
    var btn = document.querySelector('[data-sk-coupon-apply]');
    if (btn) btn.click();
  });

  // /discount/ 経由で戻ってきたら、入力欄に反映してご案内文を出す
  var params = new URLSearchParams(window.location.search);
  var applied = params.get('sk_coupon');
  if (applied) {
    var input2 = document.querySelector('[data-sk-coupon-input]');
    var note = document.querySelector('[data-sk-coupon-note]');
    if (input2) input2.value = applied;
    if (note) note.hidden = false;
  }
})();
